import { api } from '@/shared/api';
import { apiRoutes } from '@/shared/routes';
import type { WireRequest, WireResponse } from '@/shared/generated/wire';

export type {
  CreateTransactionResponse,
  MercadoPagoPaymentData,
  MercadoPagoPaymentResponse,
  StripePaymentResponse,
  Transaction,
} from './types';

import type {
  CreateTransactionResponse,
  MercadoPagoPaymentData,
  MercadoPagoPaymentResponse,
  StripePaymentResponse,
  Transaction,
} from './types';

export function createMercadoPagoPayment(data: MercadoPagoPaymentData): Promise<MercadoPagoPaymentResponse> {
  return api
    .post<WireResponse<'/app/api/wallet/mercadopago/payments', 'post', 201>>(apiRoutes.wallet.mercadopagoPayments,
      { ...data } satisfies WireRequest<'/app/api/wallet/mercadopago/payments', 'post'>)
    .then(({ status_detail, three_ds_info, ...payment }) => ({
      ...payment,
      ...(status_detail === null ? {} : { status_detail }),
      ...(three_ds_info === null ? {} : { three_ds_info }),
    }));
}

export function createStripePayment(
  transactionId: number,
  options?: { paymentMethodId?: string; saveCard?: boolean }
): Promise<StripePaymentResponse> {
  const params = {
    transaction_id: transactionId,
    ...(options?.paymentMethodId ? { payment_method_id: options.paymentMethodId } : {}),
    ...(options?.saveCard ? { save_card: true } : {}),
  } satisfies WireRequest<'/app/api/wallet/stripe/payments', 'post'>;
  return api.post<WireResponse<'/app/api/wallet/stripe/payments', 'post', 201>>(apiRoutes.wallet.stripePayments, params);
}

export function fetchTransaction(id: number): Promise<Transaction> {
  return api.get<WireResponse<'/app/api/wallet/transactions/{id}', 'get', 200>>(apiRoutes.wallet.transaction(id));
}

export function createTransaction(
  amountCents: number,
  options?: { scheduleId?: string }
): Promise<CreateTransactionResponse> {
  const params = {
    amount_cents: amountCents,
    ...(options?.scheduleId ? { schedule_id: options.scheduleId } : {}),
  } satisfies WireRequest<'/app/api/wallet/transactions', 'post'>;
  return api.post<WireResponse<'/app/api/wallet/transactions', 'post', 201>>(apiRoutes.wallet.transactions, params);
}
